module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Daisies Are Forever")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc2"
  }, [_c('i', [_vm._v("“Without remembrance, there can be no future.”")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("R")]), _vm._v(". T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HOMAS")]), _vm._v(" K"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LESTIL")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRESIDENT OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("USTRIA")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AT THE")]), _vm._v(" 55"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TH ANNIVERSARY OF THE LIBERATION OF THE")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AUTHAUSEN")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONCENTRATION")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AMP")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc2"
  }, [_c('i', [_vm._v("“Oh merciful Lord . . . crown our effort with victory . . . and give us faith in the inevitable power of light over darkness, of justice over evil and brutal force . . . so be it. Amen.”")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERGEI")]), _vm._v(", "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARCHBISHOP OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSCOW")]), _vm._v("—27 N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OVEMBER")]), _vm._v(" 1941"), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc2"
  }, [_c('i', [_vm._v("“In this world you will have trouble. But take heart! I have overcome the world.”")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OHN")]), _vm._v(" 16:33 "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NIV")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc2"
  }, [_c('i', [_vm._v("“And he saved them from the hand of him that hated them, and redeemed them from the hand of the enemy.”")]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "txc"
  }, [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALM")]), _vm._v(" 106:10 ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b56043c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/forward1.vue
// module id = 75
// module chunks = 0